import { css, Theme } from '@emotion/react'
import { scaleBorderRadius } from 'theme/utils'

export const wrapper = (theme: Theme) => css`
  width: 100%;
  max-width: 1190px;
  padding: 31px 24px;
  margin: 0 auto;
  background: ${theme.backgrounds.backgroundFour};
  position: relative;
`

export const container = css`
  width: 100%;
  height: 100%;
`

export const title = (theme: Theme) => css`
  height: 42px;
  line-height: 42px;
  font-weight: 700;

  ${theme.breakpoints.down(580)} {
    width: 100%;
  }
`

export const headerWrapper = (theme: Theme) => css`
  ${theme.breakpoints.down(580)} {
    width: 100%;
    flex-direction: column;
    align-items: end;
  }
`

export const search = (theme: Theme) => css`
  ${theme.breakpoints.down(580)} {
    width: 100%;
  }
`

export const link = (theme: Theme) => css`
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2.5)};
`

export const badge = css`
  width: fit-content;
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(2, 0)};
`

export const createButton = (theme: Theme) => css`
  position: absolute;
  top: ${theme.spacing(11)};
  right: ${theme.spacing(3)};
`
